import type { TFunction } from 'i18next';
import { z } from 'zod';

export const registerSchema = (t: TFunction<'de', undefined>) =>
    z
        .object({
            password: z.string().min(1, { message: t('users.registration.PASSWORD_SETUP.INVALID_PASSWORD') }),

            passwordRepeat: z
                .string()
                .min(1, { message: t('users.registration.PASSWORD_SETUP.INVALID_PASSWORD_REPEAT') }),
        })
        .superRefine((data, ctx) => {
            if (data.password !== data.passwordRepeat) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: t('users.registration.PASSWORD_SETUP.INVALID_PASSWORD_REPEAT'),
                    path: ['passwordRepeat'],
                });
            }
        });

export type RegisterSchema = z.infer<ReturnType<typeof registerSchema>>;
